import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useGlobalContext from '../../hook/useGlobalContext';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { useLanguage } from '../../contexts/LanguageContext';

const Sidebar = ({
  sidebarTwo,
  HOME = "HOME",
  ABOUT = "ABOUT US",
  PRODUCTS = "PRODUCTS",
  CONTACT = "CONTACT",
  PRIVACY = "PRIVACY POLICY",
  CONTACT_INFO = "Contact Info",
  ADDRESS = "3995 Rue Lesage, Sherbrooke, QC J1L 2Z9, Canada",
  EMAIL = "info@eaglevizion.com",
}) => {
  const { showSidebar, setShowSidebar } = useGlobalContext();
  const [photoIndex, setPhotoIndex] = useState(0);
  const [open, setOpen] = useState(false);

  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState({
    HOME, ABOUT, PRODUCTS, CONTACT, PRIVACY, CONTACT_INFO, ADDRESS, EMAIL,
  });

  useEffect(() => {
    const translateAll = async () => {
      const keys = ['HOME', 'ABOUT', 'PRODUCTS', 'CONTACT', 'PRIVACY', 'CONTACT_INFO', 'ADDRESS', 'EMAIL'];
      const originalTexts = { HOME, ABOUT, PRODUCTS, CONTACT, PRIVACY, CONTACT_INFO, ADDRESS, EMAIL };
      const newTranslations = {};
      const translationPromises = keys.map(async (key) => {
        const translated = await translateContent(originalTexts[key]);
        return { key, translated };
      });
      const results = await Promise.all(translationPromises);
      results.forEach(({ key, translated }) => {
        newTranslations[key] = translated;
      });
      setTranslations(newTranslations);
    };
    translateAll();
  }, [currentLanguage, HOME, ABOUT, PRODUCTS, CONTACT, PRIVACY, CONTACT_INFO, ADDRESS, EMAIL, translateContent]);

  const galleryImages = [
    { id: 1, src: 'assets/img/gallery/gal-1.jpg' },
    { id: 2, src: 'assets/img/gallery/gal-2.jpg' },
    { id: 3, src: 'assets/img/gallery/gal-3.jpg' },
    { id: 4, src: 'assets/img/gallery/gal-4.jpg' },
    { id: 5, src: 'assets/img/gallery/gal-5.jpg' },
    { id: 6, src: 'assets/img/gallery/gal-6.jpg' },
  ];

  return (
    <>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={galleryImages}
        index={photoIndex}
        on={{ view: ({ index }) => setPhotoIndex(index) }}
      />

      <div
        className={`${sidebarTwo ? 'sidebar__area sidebar__area-2' : 'sidebar__area'} ${
          showSidebar ? 'sidebar-opened' : ''
        }`}
      >
        <div className="sidebar__wrapper">
          <div className="sidebar__close">
            <button
              onClick={() => setShowSidebar(false)}
              className="sidebar__close-btn"
              id="sidebar__close-btn"
              aria-label="Close mobile menu"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          <div className="sidebar__content">
            <div className="sidebar__logo mb-30">
              <Link to="/" onClick={() => setShowSidebar(false)}>
                <img
                  src={process.env.PUBLIC_URL + '/assets/img/logo/EVLogo.png'}
                  width="60%"
                  alt="Company logo"
                />
              </Link>
            </div>

            <div className="mobile-menu fix">
              <nav id="mobile-menu" className={`${sidebarTwo ? 'd-xl-none' : 'd-lg-none'}`}>
                <ul>
                  <div className="single_link iconAdd border-0" onClick={() => setShowSidebar(false)}>
                    <li><Link to="/">{translations.HOME}</Link></li>
                    <li><Link to="/about">{translations.ABOUT}</Link></li>
                    <li><Link to="/products">{translations.PRODUCTS}</Link></li>
                    <li><Link to="/contact">{translations.CONTACT}</Link></li>
                    <li><Link to="/Politique_de_confidentialité">{translations.PRIVACY}</Link></li>
                  </div>
                </ul>
              </nav>
            </div>

            <div className="sidebar__contact mt-30 mb-20">
              <h4>{translations.CONTACT_INFO}</h4>
              <ul>
                <li className="d-flex align-items-center">
                  <div className="sidebar__contact-icon mr-15">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="sidebar__contact-icon">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.google.com/maps/place/Eagle+Vizion/@45.3969296,-71.9623181,18z/data=!3m1!4b1!4m6!3m5!1s0x4cb7b4e92c100001:0xbda1928366a88b7a!8m2!3d45.396928!4d-71.9612355!16s%2Fg%2F11q2yfvdmw?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D"
                    >
                      {translations.ADDRESS}
                    </a>
                  </div>
                </li>
                <li className="d-flex align-items-center">
                  <div className="sidebar__contact-icon mr-15">
                    <i className="fas fa-phone-alt"></i>
                  </div>
                  <div className="sidebar__contact-icon">
                    <a href="tel:+8194811325">+1 819-481-1325</a>
                  </div>
                  
                </li>
                  <li className="d-flex align-items-center">
                  <div className="sidebar__contact-icon mr-15">
                    <i className="fas fa-phone-alt"></i>
                  </div>
                  <div className="sidebar__contact-icon">
                    <a href="tel:+18332732453">+1 833 273-2453</a>
                  </div>
                  
                </li>
                <li className="d-flex align-items-center">
                  <div className="sidebar__contact-icon mr-15">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="sidebar__contact-icon">
                    <a href="mailto:info@eaglevizion.com">{translations.EMAIL}</a>
                  </div>
                </li>
              </ul>
            </div>

            <div className="sidebar__social">
              <ul>
                <li>
                  <a href="https://www.linkedin.com/company/eagle-vizion/?originalSubdomain=fr" target="_blank" rel="noreferrer">
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@eaglevizion1292" target="_blank" rel="noreferrer">
                    <i className="fab fa-youtube"></i>
                  </a>
                </li>
                <li>
                  <a href="https://fr-ca.facebook.com" target="_blank" rel="noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/?lang=fr" target="_blank" rel="noreferrer">
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      <div
        onClick={() => setShowSidebar(false)}
        className={`${showSidebar ? 'body-overlay opened' : 'body-overlay'}`}
      ></div>
    </>
  );
};

export default Sidebar;